import { Divider, Menu } from "@mui/material";
import { RatelistStatus, RatelistType } from "@sinch/core/entities/serverEnums";
import { MdsMoreHoriz } from "@sinch/icons";
import React, { useCallback } from "react";
import { ArchiveMenuItem } from "./MenuActions/ArchiveMenuItem";
import { CopyForCompanyMenuItem } from "./MenuActions/CopyForCompanyMenuItem";
import { CopyMenuItem } from "./MenuActions/CopyMenuItem";
import { DeleteMenuItem } from "./MenuActions/DeleteMenuItem";
import { RemoveFromCompanyMenuItem } from "./MenuActions/RemoveFromCompanyMenuItem";
import { RestoreMenuItem } from "./MenuActions/RestoreMenuItem";
import { RevisionsMenuItem } from "./MenuActions/RevisionsMenuItem";
import { SetDefaultForCompanyMenuItem } from "./MenuActions/SetDefaultForCompanyMenuItem";
import { SetDefaultMenuItem } from "./MenuActions/SetDefaultMenuItem";
import { MdsIcon } from "@sinch/components";
import { GridActionsCellItem } from "@sinch/components/GridActionsCellItem/GridActionsCellItem";
import { RemoveDefaultForCompanyMenuItem } from "@sinch/components/application/RatelistTable/MenuActions/RemoveDefaultForCompanyMenuItem";

export const RateRowMenu = ({
  id,
  isBeingUsed,
  status,
  onPerformedAction,
  type,
  hasLineage,
  isDefault,
  companyId,
  isCompanySpecific,
  isDefaultForCompany,
  isGlobal,
}: {
  type: RatelistType;
  id: string;
  isBeingUsed: boolean;
  status: RatelistStatus;
  onPerformedAction: () => void;
  hasLineage: boolean;
  isDefault: boolean;
  companyId?: string;
  isCompanySpecific?: boolean;
  isDefaultForCompany?: boolean;
  isGlobal?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const archived = status === RatelistStatus.Archived;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePerformedAction = useCallback(() => {
    onPerformedAction?.();
    handleClose();
  }, [onPerformedAction]);

  const allowDefaultForCompany = !isDefault && companyId && status === RatelistStatus.Active && !isDefaultForCompany;
  const isCompanyExclusive = companyId && isCompanySpecific && !isDefaultForCompany;
  const allowCompanyRemove = !isGlobal && companyId && !isCompanySpecific;
  const allowSetDefault = !companyId && status === RatelistStatus.Active && !isDefault;
  const allowArchive = !isDefault && !archived;
  const allowRestore = !isDefault && archived;
  const allowDelete = !isDefault;
  return (
    <div>
      <GridActionsCellItem color="info" icon={<MdsIcon icon={MdsMoreHoriz} />} label={<></>} onClick={handleClick} />
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        disableScrollLock
        id="basic-menu"
        onClose={handleClose}
        open={open}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {!companyId && <CopyMenuItem id={id} type={type} />}
        {companyId && <CopyForCompanyMenuItem companyId={companyId} id={id} type={type} />}
        {allowSetDefault && <SetDefaultMenuItem id={id} onPerformedAction={handlePerformedAction} />}
        {allowDefaultForCompany && (
          <SetDefaultForCompanyMenuItem companyId={companyId} id={id} onPerformedAction={handlePerformedAction} />
        )}
        {companyId && isDefaultForCompany && (
          <RemoveDefaultForCompanyMenuItem
            companyId={companyId}
            onPerformedAction={handlePerformedAction}
            type={type}
          />
        )}
        {(allowSetDefault || allowDefaultForCompany) && <Divider />}
        {hasLineage && <RevisionsMenuItem id={id} type={type} />}
        {hasLineage && <Divider />}

        {allowArchive && <ArchiveMenuItem id={id} onPerformedAction={handlePerformedAction} />}
        {allowRestore && <RestoreMenuItem id={id} onPerformedAction={handlePerformedAction} />}

        {(isCompanyExclusive || allowDelete) && (
          <DeleteMenuItem disabled={hasLineage || isBeingUsed} id={id} onPerformedAction={handlePerformedAction} />
        )}
        {allowCompanyRemove && (
          <>
            <Divider />
            <RemoveFromCompanyMenuItem companyId={companyId} id={id} onPerformedAction={handlePerformedAction} />
          </>
        )}
      </Menu>
    </div>
  );
};
